import config from '../../config';

import { BaseRequestService } from './BaseRequest.service';
import { INewsService } from './types';

const API_URLS = {
  /**
   * @deprecated Integrated before but there is no usage in WEB and MOBILE
   * This is an outdated integration. We fetch news from the WS.
   */
  getNews: '/News/latest/',
  /**
   * @deprecated Integrated before but there is no usage in WEB and MOBILE
   * This is an outdated integration. We fetch news from the WS.
   */
  getNewsFromCache: '/News/latest/from-cache',
};

export class NewsService extends BaseRequestService implements INewsService {
  private static instance: NewsService;

  protected getBaseUrl(): string {
    return config.news.url;
  }

  private constructor() {
    super();
  }

  static getInstance(): NewsService {
    if (!this.instance) {
      this.instance = new NewsService();
    }
    return this.instance;
  }
}
